import React, { createElement } from "react"
import Carousel from "../carousel"
import { kebabCase } from "lodash"
import { Link } from "gatsby"
import StyledImage from "../styled-image"
import Cta from "../cta"

export default function PageList({ props }) {
  const { heading, pages, background } = props
  const carouselSettingsOverrides = {
    slidesToShow: 3,
    slidesToScroll: 3,
    className: `slick-arrows-centered slick-arrows-wide -mx-[1px]`,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  return (
    <section className={`${background === "gradient" ? "bg-banner-gradient/10" : ""}`}>
      <div className="container py-10" id="dining-options">
        <div className="mb-10 md:text-center max-w-5xl mx-auto">
          {heading ? <h2 id={kebabCase(heading)} className="mb-4 ">{heading}</h2> : null}
        </div>
        {pages ?
          <>
            <div className={`${pages.length > 3 ? "" : "lg:hidden"} mb-10 px-2`}>
              <Carousel settingsOverrides={carouselSettingsOverrides}>
                {pages.map((page, index) => {
                  return (
                    <PageCard props={page} key={index} />
                  )
                })
                }
              </Carousel>
            </div>


            <ul className={`hidden ${pages.length > 3 ? "" : "lg:grid"} -mx-4 xl:-mx-8 lg:grid-cols-3 gap-x-4 gap-y-10 mb-10`}>
              {pages.map((page, index) => {
                return (
                  <li key={index} className="flex">
                    <PageCard props={page} />
                  </li>
                )
              }
              )}
            </ul>

          </> : null}
      </div>
    </section>
  )
}
const PageCard = ({ props }) => {
  const { title, uri, excerpt, featuredImage, pageOptions } = props
  const image = featuredImage?.node
  const cta = {
    title: title,
    url: uri,
  }
  const { hidePageLink } = pageOptions
  const LinkWrapper = (hidePageLink) => createElement((hidePageLink) ? "span" : Link, hidePageLink)

  return (

    <div className={`mx-auto md:mx-0 max-w-md md:max-w-md px-4 xl:px-8 flex flex-col flex-grow self-stretch`}>
      {image ? (
        <div
          className={`print:max-w-sm flex justify-center block-img relative w-full aspect-video`}
        >
          <LinkWrapper to={hidePageLink ? undefined : cta.url} className="block">
            <StyledImage
              image={image}
              objectFit="cover"
              className={`w-full aspect-video`} />
          </LinkWrapper>
        </div>
      ) : null}


      <div className={`flex-grow self-stretch w-5/6 sm:w-11/12 mx-auto bg-white shadow-spread-xs lg:shadow-spread ${image ? "-mt-4" : ""} py-4 px-5 relative rounded`}>
        {title ?
          <h3 className='mb-2'>
            <LinkWrapper to={hidePageLink ? undefined : cta.url} className="text-body">
              {title}
            </LinkWrapper>
          </h3> : null}
        {excerpt && (
          <div className="mb-2 text-sm sm:text-base parsed-content">
            <div
              dangerouslySetInnerHTML={{
                __html: excerpt,
              }}
            />
          </div>
        )}
        {hidePageLink ? <span className="btn-text disabled">Coming Soon</span> : <Cta props={cta} />}
      </div>
    </div>
  )

}
